<template>
  <div class="design-scope-items">
    <div class="required">
      <p>Required design sheets</p>
      <scope-items-list :items="designSheets" />
    </div>
    <div class="additional mt-10">
      <p>Additional services</p>
      <scope-items-list :items="additionalServices" />
    </div>
  </div>
</template>

<script>
import ScopeItemsList from "./ScopeItemsList";

export default {
  name: "DesignScopeItems",
  components: { ScopeItemsList },
  computed: {
    designSheets() {
      let designSheets = this.$store.state.Settings.designSheets;
      if (designSheets) {
        designSheets.sort((a, b) => a.name.localeCompare(b.name));
      }
      return designSheets;
    },
    additionalServices() {
      let additionalServices = this.$store.state.Settings.additionalServices;
      if (additionalServices) {
        additionalServices.sort((a, b) => a.name.localeCompare(b.name));
      }
      return additionalServices;
    }
  },
  created() {
    if (this.designSheets === null || this.additionalServices === null) {
      this.$store.dispatch("getAllScopeItems");
    }
  }
};
</script>

<style scoped></style>
